'use client';

import { NavigationCarousel } from '@/features/carousel';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { BlackProductCard } from './black-product-card';
import BlackProductsSkeleton from './black-products-skeleton';
import blackProductsData from './black-products.json';
const BlackProductsList = () => {
  return <div className='homepage-container relative my-2 min-h-[235px] !pl-0 lg:min-h-[336px]' data-sentry-component="BlackProductsList" data-sentry-source-file="black-products-list.tsx">
            <NavigationCarousel options={{
      perView: 'auto',
      mode: 'free-snap',
      spacing: 8
    }} skeleton={<BlackProductsSkeleton />} staticChildren data-sentry-element="NavigationCarousel" data-sentry-source-file="black-products-list.tsx">
                {blackProductsData.products.map((item, index) => {
        return <div key={index} data-index={index} className='keen-slider__slide min-w-fit max-w-fit px-0'>
                            <BlackProductCard name={item.name} brand={item.brand} basePrice={item.basePrice} salesPrice={item.salesPrice} discountPercent={item.discountPercent} image={item.image} isLazy={!PUBLIC_IS_BOT} />
                        </div>;
      })}
            </NavigationCarousel>
        </div>;
};
export default BlackProductsList;